"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _config = require("../config");
var _helpers = require("../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ImageContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageContainer, _React$Component);
  var _super = _createSuper(ImageContainer);
  function ImageContainer(props) {
    var _this;
    _classCallCheck(this, ImageContainer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.props.onDelete(_this.props.image);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      _this.setState({
        hovred: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        hovred: false
      });
    });
    _this.state = {
      hovred: false
    };
    return _this;
  }
  _createClass(ImageContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        image = _this$props.image,
        fullWidth = _this$props.fullWidth,
        extraImageContainerStyles = _this$props.extraImageContainerStyles,
        extraDeleteImageStyles = _this$props.extraDeleteImageStyles;
      var hovred = this.state.hovred;
      return /*#__PURE__*/_react.default.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        style: _objectSpread({
          border: '1px solid #bdbdbd',
          borderRadius: 4,
          display: 'block',
          height: 140,
          margin: 4,
          padding: 0,
          position: 'relative',
          textAlign: 'center',
          width: fullWidth ? '100%' : '30%'
        }, extraImageContainerStyles)
      }, !!image && /*#__PURE__*/_react.default.createElement("img", {
        src: image.url ? (0, _helpers.joinPaths)(_config.BASE_URL, image.url) : image.data,
        alt: "",
        style: {
          borderRadius: 4,
          height: '100%',
          left: 0,
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          width: '100%'
        }
      }), image && hovred && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          background: 'rgba(0, 0, 0, 0.5)',
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          color: '#fff',
          display: 'flex',
          fontSize: '14px',
          height: '25%',
          left: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          color: '#fff',
          flexGrow: 1,
          marginLeft: '70%',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: this.handleClick,
        style: _objectSpread({
          color: 'rgba(255, 255, 255, 0.54)'
        }, extraDeleteImageStyles)
      }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "clear")))));
    }
  }]);
  return ImageContainer;
}(_react.default.Component);
var _default = ImageContainer;
exports.default = _default;